export const today = () => {
  const pad = (n: number) => Math.abs(n).toString().padStart(2, '0')

  const d = new Date()
  const year = pad(d.getFullYear())
  const month = pad(d.getMonth() + 1)
  const day = pad(d.getDate())

  return `${year}-${month}-${day}`
}
